import styled from 'styled-components/macro'
import { Link } from '@resultadosdigitais/tangram-components'

const StyledLink = styled(Link)`
  font-size: var(--text-size-xs);
  text-decoration: none;

  :hover {
    color: var(--color-gray-70);
    text-decoration: none;

    svg {
      fill: var(--color-gray-70);
    }
  }
`

export default StyledLink
